import httpService from '../../../../services/http.service';
import {
	mockInvitationHistory,
	USE_MOCK_HISTORY,
} from './InviteHistoryDrawer.mock';


export interface InvitationHistoryEntry {
	status: 'SUCCESS' | 'FAILURE';
	/** explanation for delivery failures - only set when status is FAILURE */
	failureReason: string | null;
	channel: 'EMAIL' | 'SMS';
	/** recipient phone number, when the invitation was sent by SMS */
	phone: string | null;
	/** recipient email address, when the invitation was sent by email */
	email: string | null;
	/** ISO-8601 date-time of the send attempt */
	timestamp: string;
}

export interface InvitationHistoryResponse {
	userId: string;
	totalCount: number;
	history: InvitationHistoryEntry[];
}

/** legalId is the user's teudat zeut, taken from the table row */
export const fetchInvitationHistory = (
	legalId: string,
): Promise<InvitationHistoryResponse | undefined> =>
	USE_MOCK_HISTORY
		? mockInvitationHistory(legalId)
		: httpService.api<InvitationHistoryResponse>({
				type: 'getUserInvitationHistory',
				params: { legalId },
				disableBI: true,
		  });
